module.exports = __webpack_public_path__ + "static/media/BAJHASPP.d24dca6d.png";